import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Message from './Message';

// Hide an element visually and from screen readers
const LiveRegion = styled.div`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
  position: absolute;
`;

/**
 * A container which consist with two blocks for polite and assertive messages
 * to notify assistive technologies when content changes dynamically without page reload.
*/

const LiveRegionContainer = ({ assertiveMessage, politeMessage }) => (
  <LiveRegion>
    <Message ariaLive="polite" message={politeMessage} />
    <Message ariaLive="assertive" message={assertiveMessage} />
  </LiveRegion>
);

LiveRegionContainer.propTypes = {
  assertiveMessage: PropTypes.string,
  politeMessage: PropTypes.string,
};

LiveRegionContainer.defaultProps = {
  assertiveMessage: '',
  politeMessage: '',
};

export default connect(({ regionMessages: { politeMessage, assertiveMessage } }) => ({
  politeMessage,
  assertiveMessage,
}))(LiveRegionContainer);
